import update from "immutability-helper";
import _ from "underscore";

const createEntryListReducer =
  (type) =>
  (state = { entries: [] }, action) => {
    switch (action.type) {
      case `ADD_${type}`: {
        return update(state, { entries: { $push: [action.payload] } });
      }
      case `MODIFY_${type}`: {
        if (state.entries[action.index] === undefined) {
          return update(state, {
            entries: { $push: [{ value: action.payload.value }] },
          });
        }

        const settings = {
          entries: {
            [action.index]: {
              value: { $set: action.payload.value },
              $unset: ["error"],
            },
          },
        };
        return update(state, settings);
      }
      case `REMOVE_${type}`: {
        // console.log(`reducer REMOVE_${type} action hit`);
        // if (state.entries.length - 1 !== action.index) {
        return update(state, { entries: { $splice: [[action.index, 1]] } });
        // } else {
        //   // console.log(state.entries);
        //   update(state, {entries: {[action.index]: {value: {$set: ''}}}})
        //   return update(state, {entries: {[action.index]: {value: {$set: ''}}}})
        // }
      }
      case `CLEAR_${type}`: {
        // console.log(`reducer REMOVE_${type} action hit`);
        return update(state, { entries: { $set: [] } });
      }
      case `ADD_POPULAR_${type}`: {
        // console.log(`reducer REMOVE_${type} action hit`);
        return update(state, { entries: { $push: [action.payload] } });
        // return update(state, {entries: {$splice: [[action.index, 1]]}})
      }
      case `REMOVE_POPULAR_${type}`: {
        // console.log(`reducer REMOVE_${type} action hit`);
        const entryIndex = _.findIndex(
          state.entries,
          (entry) => action.payload.suggested_question_id === entry.suggested_question_id
        );

        if (entryIndex !== -1) {
          return update(state, { entries: { $splice: [[entryIndex, 1]] } });
        }
        // return update(state, {entries: {$splice: [[action.index, 1]]}})
        return state;
      }
      case `ERROR_${type}`: {
        console.log(type, action);
        return update(state, {
          entries: {
            [action.index]: { error: { $set: action.payload.error } },
          },
        });
      }
      default:
        return state;
    }
  };

export default createEntryListReducer;
